import { render, staticRenderFns } from "./LoginBusinessHighest.vue?vue&type=template&id=0fa3fe5a&scoped=true&"
import script from "./LoginBusinessHighest.vue?vue&type=script&lang=js&"
export * from "./LoginBusinessHighest.vue?vue&type=script&lang=js&"
import style0 from "./LoginBusinessHighest.vue?vue&type=style&index=0&id=0fa3fe5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3fe5a",
  null
  
)

export default component.exports